import { CommonService } from './../Services/common.service';
import { Component, OnInit, Output, EventEmitter, Input, Provider } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { Subject } from "rxjs";
import { AuthService } from '../Services/auth.service';
import { ToastrService } from "ngx-toastr";
import { CookieService } from '../Services/cookie';
import { SettingService } from '../Services/setting.service';


@Component({
  selector: 'app-mobile-otp-verify',
  templateUrl: './mobile-otp-verify.component.html',
  standalone:false,
  styleUrls: ['./mobile-otp-verify.component.scss']
})
export class MobileOtpVerifyComponent implements OnInit {
  modalObservable: Subject<void> = new Subject<void>();
  NewEMail: any;
  NewMOb: any;
  RegisterIdno: any;

  constructor(
    private toastr: ToastrService,
    private _route: ActivatedRoute,
    public CommonService: CommonService,
    public auth: AuthService, private cookieService: CookieService, private setting: SettingService,
    private _router: Router
  ) {
    // this.toastr.error("Incorrect OTP entered. Try again.", "Error");
  }

  @Output() doneButton: EventEmitter<any> = new EventEmitter<any>();

  mobilemask: string = "";
  otp: string = "";
  timerexpire: string;
  OptTimerbtnShow: boolean = true;
  timeoutHandle;
  idno;
  UpdateEmail: string = "";
  IDNo: string = "";

  async ngOnInit(): Promise<any> {

    this.auth.accessToken = await this.CommonService.Get("token");


// 
this.CommonService.presentLoading();
this.auth.accessToken = await this.CommonService.Get("token");
this.auth.VerifyToken({}, this.auth.accessToken).then(async (data: any) => {
  if (data?.response?.code == 1) {
   this.CommonService.hideLoading();
   this.startTime();


  }
  else {
    await this.CommonService.hideLoading();
    this.CommonService.ParseErrorAlert("", "", this._router, data);
  }

});
// 

  
    this._route.queryParams.subscribe((params) => {
      if (params) {
        if (params['maskmobile']) {

        }
        if (params['id']) {
          this.idno = params['id'];
        }

        if (params['UpdateEmail']) {
          //
          this.UpdateEmail = params['UpdateEmail'];
        }
        if (params['IDNo']) {
          //
          this.IDNo = params['IDNo'];
        }
      }

    });
    if (this.auth?.RegisteredUser == undefined) {
    let R = this.cookieService.get("xVal", true);
    if (R) {

      this.RegisterIdno = R;
 
      

    }
         console.log("IncreptedIDNo2",this.RegisterIdno);
  }

    let UE =await this.cookieService.get("UpdatedEmail", false);
    if (UE) {

      this.NewEMail = JSON.parse(UE);

    }

    let UM =await this.cookieService.get("upM32B", true);
    if (UM) {

      this.NewMOb = JSON.parse(UM);

    }

    if(this.auth.RegisteredUser?.mobile == undefined &&(this.mobilemask == undefined|| this.mobilemask == "")){

      let M =await this.cookieService.get("minfo", true);
      if (M) {

       this.mobilemask = M;

      }
    }
    

  }


  LoginRegister() {
    //
    this.CommonService.presentLoading();
    if (this.IDNo != "" && this.UpdateEmail != "") {
      let body = {
        UniqueId: this.CommonService.Guid(),
        idNumber: this.IDNo? this.IDNo : this.RegisterIdno ,
        IsUpdateEmailFlow: true,
        EmailId: this.UpdateEmail,
        isBusiness: false,
        firebaseToken: "string",
        otp: this.otp,
      };

      this.auth.LoginRegister(body).then((data: any) => {
        //
        if (data?.response?.code == 1) {
          this.CommonService.hideLoading();
          this.auth.deviceid = data.response.content.l.webdeviceId;
          //
          this._router.navigateByUrl("/CreateAppPin");
        } else {
          this.CommonService.hideLoading();
          this.CommonService.ParseErrorAlert("", "", this._router, data);
        }
      });
    } else {
      let body = {
        UniqueId: this.CommonService.Guid(),
        idNumber: this.auth.RegisteredUser?.idno ? this.auth.RegisteredUser.idno: this.RegisterIdno,
        isBusiness: false,
        firebaseToken: "string",
        otp: this.otp,
      };
      this.auth.LoginRegister(body).then((data: any) => {

        if (data?.response?.code == 1) {

          this.auth.deviceid = data.response.content.webdeviceId;

   
          // this.cookieService.set("detailuser",JSON.stringify(data.response.content.l),false,undefined,undefined,undefined,undefined,true,"Strict")

          this.CommonService.hideLoading();
          this._router.navigateByUrl("/Dashboard");

        }
        else if(data?.error?.response?.code == 7){

          this.CommonService.hideLoading();
          this.CommonService.ParseErrorAlert("", "", this._router, data?.error?.response?.message);

        } else {
          this.CommonService.hideLoading();
          this.CommonService.ParseErrorAlert("", "", this._router, data);
        }
      });
    }
  }

  Next() {
    this._router.navigateByUrl("/ChangeCardPinSinnadSuccess");
  }

  async VerifyMobileOtp() {
    let body = {
      EmailId: this.NewEMail,
      OTPCode: this.otp,
    };

    await this.CommonService.presentLoading();
    this.setting.VerifyChangeEmailSMSOTP(this.auth.accessToken, body)
      .then(async (data: any) => {
        if (data?.response?.code == 1) {
          await this.CommonService.hideLoading();
          this._router.navigateByUrl("/ChangeCardPinSinnadSuccess");
        } else {
          await this.CommonService.hideLoading();
          this.CommonService.ParseErrorAlert("", "", this._router, data);
        }
      });
  }



  verifyViaMobileOtp() {
    let body = {
      MobileNumber: this.NewMOb,
      OTPCode: this.otp,
    };
    this.CommonService.presentLoading();
    this.setting
      .VerifyChangeMobileSMSOTP(this.auth.accessToken, body)
      .then((data: any) => {
        if (data?.response.code == 1) {
          this.CommonService.hideLoading();
          this._router.navigateByUrl("/Settings");
        } else {
          this.CommonService.hideLoading();
          this.CommonService.ParseErrorAlert("", "", this._router, data);
        }
      });
  }
  showModal(num) {
    this.modalObservable.next(num);
  }

  // startTime() {
  //   var str = "1:57";

  //   var array = str.split(":");
  //   this.countdown(parseInt(array[0]), parseInt(array[1]));
  // }

  // countdown(minutes, seconds) {
  //   this.timeoutHandle;
  //   var that = this;
  //   function tick() {
  //     that.timerexpire =
  //       minutes.toString() + ":" + (seconds < 10 ? "0" : "") + String(seconds);
  //     seconds--;
  //     if (seconds >= 0) {
  //       that.timeoutHandle = setTimeout(tick, 1000);
  //     } else {
  //       if (minutes >= 1) {
  //         setTimeout(function () {
  //           that.countdown(minutes - 1, 59);
  //         }, 1000);
  //       }
  //     }

  //     if (that.timerexpire == "0:00") {
  //       that.OptTimerbtnShow = false;
  //     }
  //   }
  //   tick();
  // }


    // new timer
  startTime() {
  const expireTime = new Date().getTime() + 2 * 60 * 1000; // 2 minutes from now
  this.startCountdown(expireTime);
}

startCountdown(expireTimestamp: number) {
  const tick = () => {
    const now = new Date().getTime();
    const remaining = expireTimestamp - now;

    if (remaining <= 0) {
      this.timerexpire = "0:00";
      this.OptTimerbtnShow = false;
      return;
    }

    const minutes = Math.floor((remaining % (1000 * 60 * 60)) / (1000 * 60));
    const seconds = Math.floor((remaining % (1000 * 60)) / 1000);

    this.timerexpire = `${minutes}:${seconds < 10 ? '0' : ''}${seconds}`;
    setTimeout(tick, 1000);
  };

  tick();
}

  ResendOtp() {
    this.CommonService.presentLoading();
    let body = {
      UniqueId: this.CommonService.Guid(),
      idNumber: this.auth.RegisteredUser?.idno ? this.auth.RegisteredUser.idno: this.RegisterIdno,
    };

    this.auth.ResendSMSRegistrationOTP(body, this.auth.accessToken).then((data: any) => {
      if (data?.response?.code == 1) {
        this.OptTimerbtnShow = true;
        this.startTime();
        this.CommonService.hideLoading();
      }
       else {
        this.CommonService.hideLoading();
        this.CommonService.ParseErrorAlert('', '', this._router, data);

      }
    });
  }

  continue() {
    // this._router.navigateByUrl("/UploadId");
    this._router.navigateByUrl("/UploadIdDetails");
  }

  isValid() {
    if (!this.otp) {
      return true;
    } else {
      return false;
    }
  }

  onOtpChange(e) {
    if (e.length == 4) {
      this.otp = e.toString();
    } else {
      this.otp = "";
    }
  }
  loginWithIdNum() {
    this._router.navigateByUrl("/LoginWithIdNum");
  }
  createAppPin() {
    this._router.navigateByUrl("/CreateAppPin");
  }

  onKeyDown(event: KeyboardEvent): void {
    if (event.key === "Enter") {
 if (this.NewEMail != undefined && this.NewEMail != "") {
      this.VerifyMobileOtp();
    }
    else if(this.NewMOb != undefined && this.NewMOb != ""){
      this.verifyViaMobileOtp();
    }
    else {
      // this.LoginRegister()
    }    }
  }
}



